import type { InputHTMLAttributes } from "react";

import { cn } from "@/lib/utils";

import { InlineError } from "./inline-error";

export const TextField = ({
  accessory,
  error,
  id,
  label,
  ...input
}: {
  accessory?: string;
  error?: string | null;
  id: string;
  label: string;
} & InputHTMLAttributes<HTMLInputElement>) => {
  const errorId = error ? `${id}-error` : undefined;
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-baseline justify-between gap-4">
        <label className="font-medium text-sm" htmlFor={id}>
          {label}
        </label>
        {accessory ? (
          <span className="text-[13px] text-n-600">{accessory}</span>
        ) : null}
      </div>
      <input
        aria-describedby={errorId}
        aria-invalid={error ? true : undefined}
        className={cn(
          "auth-focus box-border h-[52px] w-full rounded-[10px] border bg-white px-4 text-base text-navy-900 placeholder:text-n-600/70",
          error ? "border-error" : "border-n-600"
        )}
        id={id}
        {...input}
      />
      <InlineError id={errorId} message={error ?? null} />
    </div>
  );
};
